// extracted by mini-css-extract-plugin
export default {"Congratulations":"Congratulations_Congratulations__kvjBq","Paper":"Congratulations_Paper__KqpfB","animation":"Congratulations_animation__lMT6V"};